export default class ScNewsletterPopUp {
  constructor() {
    this.elementSelector = '.js-swa-sc-nl-popup';
    this.linkSelector = '.js-swa-sc-nl-popup-expand';
    this.closeBtnSelector = '.js-swa-sc-nl-popup-close-icon';
  }

  init() {
    const nlPopupElement = document.querySelector(this.elementSelector);
    const expandLinkElement = document.querySelector(this.linkSelector);
    const closeBtnElement = document.querySelector(this.closeBtnSelector);

    if (!nlPopupElement || !expandLinkElement) {
      return;
    }

    closeBtnElement.addEventListener('click', () => {
      nlPopupElement.classList.add('swa-hidden');

      // Only for demo purposes in PL, this logic exists in hybris in acc.newsletterpopup.js
      if (document.querySelector('.js-patternlab-page')) {
        this.servicesPopUp = document.querySelector('.js-swa-services-popup');
        // Reset service popup to initial bottom value if newsletter popup is closed
        if (this.servicesPopUp) {
          this.servicesPopUp.style.bottom = '35px';
        }
      }
    });

    // Only for demo purposes in PL, this logic exists in hybris in acc.newsletterpopup.js
    if (document.querySelector('.js-patternlab-page')) {
      this.servicesPopUp = document.querySelector('.js-swa-services-popup');
      expandLinkElement.addEventListener('click', () => {
        nlPopupElement.classList.toggle('swa-sc-nl-popup--open');
      });
    }
  }
}
